import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { LifecycleAware } from '@lsq-frontend/common-ui';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { GetFlexTermAvailabilityResponse } from '@lsq-frontend/remote-services/financing-graphql';
import { LsqDataSource } from '@lsq-frontend/angular-shared/api-service';
import { Money } from '@lsq-frontend/remote-services/funding-api';

@LifecycleAware()
@Component({
    selector: 'flex-term-availability-tile',
    styleUrls: ['./flex-term-availability-tile.component.scss'],
    encapsulation: ViewEncapsulation.None,
    template: `
        <card class="flex-term-availability-card">
            <div card-header>
                <h3 id="flex-term-availability-heading" i18n>FlexTerm Availability</h3>
            </div>
            <div class="flex-term-availability-card-body" card-body>
                <lsq-circle-loader *ngIf="dataSource.loading$ | async"></lsq-circle-loader>
                <ng-container *ngIf="!(dataSource.loading$ | async)">
                    <div>
                        <div class="flex-term-availability-section">
                            <div class="flex-term-availability-section-label">
                                {{ eligibleInvoiceCount }}
                            </div>
                            <div class="flex-term-availability-section-value">
                                {{ invoiceCount | number }}
                            </div>
                        </div>
                        <div class="flex-term-availability-section">
                            <div class="flex-term-availability-section-label">
                                {{ eligibleInvoiceAmount }}
                            </div>
                            <div class="flex-term-availability-section-value">
                                {{ invoiceAmount | lsqCurrency }}
                            </div>
                        </div>
                        <div class="flex-term-availability-section" *ngIf="showRequestButton">
                            <lsq-button
                                class="flex-term-availability-button"
                                [routerLink]="flexTermUrl"
                                size="md"
                            >
                                Request FlexTerm
                            </lsq-button>
                        </div>
                    </div>
                </ng-container>
            </div>
        </card>
    `
})
export class FlexTermAvailabilityTileComponent implements OnInit {
    @Input() public dataSource!: LsqDataSource<GetFlexTermAvailabilityResponse>;
    @Input() public flexTermUrl!: string;
    @Input() public showRequestButton = false;

    public readonly eligibleInvoiceCount = this._i18n({
        value: 'Eligible Invoice Count',
        meaning: 'Total number of eligible invoices for flexterm'
    });

    public readonly eligibleInvoiceAmount = this._i18n({
        value: 'Eligible Invoice Amount',
        meaning: 'Total amount eligible for flexterm'
    });

    public invoiceCount: number;
    public invoiceAmount: Money;

    constructor(private _i18n: I18n) {}

    public ngOnInit(): void {
        this.dataSource.data$.subscribe((data) => {
            this.invoiceCount = data.openElegibleFlexTermPayableCount!!;
            this.invoiceAmount = data.eligibleAmount!!;
        });
    }
}
